export default function ImageModalContent({ src }) {
    return (
        <>
            <div className="modal-body image-modal-body">
                <img alt="modal" src={src} />
            </div>
        </>
    )
}
